/**
 * ConsumerPaymentTag automatically generated by SDKgen please do not edit this file manually
 * {@link https://sdkgen.app}
 */

import {TagAbstract, HttpRequest} from "sdkgen-client"
import {ClientException, UnknownStatusCodeException} from "sdkgen-client";

import {CommonMessage} from "./CommonMessage";
import {CommonMessageException} from "./CommonMessageException";
import {ConsumerPaymentCheckoutRequest} from "./ConsumerPaymentCheckoutRequest";
import {ConsumerPaymentCheckoutResponse} from "./ConsumerPaymentCheckoutResponse";
import {ConsumerPaymentPortalRequest} from "./ConsumerPaymentPortalRequest";
import {ConsumerPaymentPortalResponse} from "./ConsumerPaymentPortalResponse";

export class ConsumerPaymentTag extends TagAbstract {
    /**
     * Start the checkout process for a specific plan
     *
     * @returns {Promise<ConsumerPaymentCheckoutResponse>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async checkout(provider: string, payload: ConsumerPaymentCheckoutRequest): Promise<ConsumerPaymentCheckoutResponse> {
        const url = this.parser.url('/consumer/payment/:provider/checkout', {
            'provider': provider,
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerPaymentCheckoutResponse;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }
    /**
     * Generates a payment portal link for the authenticated user
     *
     * @returns {Promise<ConsumerPaymentPortalResponse>}
     * @throws {CommonMessageException}
     * @throws {ClientException}
     */
    public async portal(provider: string, payload: ConsumerPaymentPortalRequest): Promise<ConsumerPaymentPortalResponse> {
        const url = this.parser.url('/consumer/payment/:provider/portal', {
            'provider': provider,
        });

        let request: HttpRequest = {
            url: url,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            params: this.parser.query({
            }, [
            ]),
            data: payload
        };

        const response = await this.httpClient.request(request);
        if (response.ok) {
            return await response.json() as ConsumerPaymentPortalResponse;
        }

        const statusCode = response.status;
        if (statusCode >= 0 && statusCode <= 999) {
            throw new CommonMessageException(await response.json() as CommonMessage);
        }

        throw new UnknownStatusCodeException('The server returned an unknown status code: ' + statusCode);
    }



}
